import { Loader } from "common";
import React from "react";
import { Membership, ProductObject } from "types";
import { NoProductsAlert } from "../NoProductsAlert";
import { MembershipTile } from "./MembershipTile";

interface MembershipListProps {
    memberships: Membership[];
    isLoading: boolean;
    isFiltered: boolean;
}

export const MembershipList = ({ memberships = [], isLoading, isFiltered }: MembershipListProps) => {
    if (isLoading) {
        return <Loader size="tiny" className="p-2" text="Loading Memberships" />;
    }

    if (memberships.length === 0 && isFiltered) {
        return (
            <div className="py-15 px-10">
                <NoProductsAlert isListFiltered object={ProductObject.MEMBERSHIP} />
            </div>
        );
    }

    return (
        <div>
            {isLoading ? (
                <Loader size="tiny" className="p-2" text="Loading Memebership Passes" />
            ) : (
                <div className="py-15 px-10">
                    {memberships.length > 0 || isFiltered ? (
                        <div className="grid grid-cols-2 gap-y-10 gap-x-12">
                            {memberships.map((membership: Membership) => (
                                <MembershipTile key={membership.id} membership={membership} />
                            ))}
                        </div>
                    ) : (
                        <NoProductsAlert object={ProductObject.MEMBERSHIP} />
                    )}
                </div>
            )}
        </div>
    );
};
